export { default } from '../features/auth/ForgotPassword';
